import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Redacted from "../Redacted/Redacted";

const AuxColumn = ({secTitle, payload, showKeys=true, baseDelay=0}) => {
    const [keys, setKeys] = useState(null)
    const [values, setValues] = useState(null);

    const handleSpecialValues = (key, val) => {
        let newVal = val;
        if(key == "runTime") newVal = `${val[0]}m ${val[1]}s`;
        else if(key == "coords"){
            if(val) newVal = `${val[0]}, ${val[1]}`
            else newVal = ""
        }
        return newVal
    }

    useEffect(() => {
        if(payload){
            let tmpKeys = [];
            let tmpVals = [];
            for (const [key, val] of Object.entries(payload)) {
                if(key == 'runTime') continue;
                tmpKeys.push(key);
                tmpVals.push(val)
            }
            setKeys(tmpKeys)
            setValues(tmpVals);
            let newKeys = [];
            if(showKeys){
                for(let i = 0; i< tmpKeys.length; i++){
                    let spaced = tmpKeys[i].replace("_", " ");
                    let first = spaced.replace("first", "1st");
                    let second = first.replace("second", "2nd");
                    let third = second.replace("third", "3rd");
                    newKeys.push(third)
                }
            } else{
                for(let i = 0; i< tmpKeys.length; i++){
                    tmpVals[i] = handleSpecialValues(tmpKeys[i], tmpVals[i])
                }
                newKeys = Array(tmpVals.length).fill(" ");
            }
            setKeys(newKeys);
            setValues(tmpVals)
        }
    }, [payload])

    return(
        <>
            <div className="credit__wrapper">
                {
                    secTitle &&
                    <div className="m_title ">
                        <div className="m-inf__wrapper">
                        <span className="">
                            <Redacted delay={baseDelay} duration={0.65}/>
                            {secTitle}
                        </span>
                        </div>
                    </div>
                }
                {
                    showKeys &&
                    <div className="meta_col_keys">
                        {keys && keys.map((item, idx) => (
                            <div className="mk m-inf__wrapper">
                                <span className="meta_key ">
                                    <Redacted delay={baseDelay + ((0.25 + (idx * 0.15)) * Math.random())} duration={0.5 + 0.35*Math.random()}/>
                                    {item.replace("_", " ").replace("first", "1st")}
                                </span>
                            </div>
                        ))}
                        
                    </div>
                }
                <div className="meta_col_values">
                    {
                        values && values.map((item, idx) => (
                            <div className="mv m-inf__wrapper">
                                <span className="meta_val " style={{
                                    display: Array.isArray(item) ? "flex" : "",
                                    flexDirection: Array.isArray(item) ? "column" : ""
                                }}>
                                    <Redacted delay={baseDelay + ((0.5 + (idx * 0.15)) * Math.random())} duration={0.5 + 0.6*Math.random()}/>
                                    {
                                        Array.isArray(item) ?
                                            item.map((subitem, subidx) => (
                                                <span>{subitem}</span>
                                            ))
                                        : item
                                    }
                                </span>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default AuxColumn;